export enum ColumnType {
  year = "year",
  status = "status",
  expenseSummary = "expenseSummary",
  totalCollectedFeeSum = "totalCollectedFeeSum",
  balance = "balance",
}

export const columnLabels = Object.values(ColumnType);
